module.exports = __webpack_public_path__ + "media/images/vp/samples/04-88364c5223ddba88d482b9b388b19904.jpg";